// extracted by mini-css-extract-plugin
module.exports = {"StatusInfoPanel":"StatusInfoPanel_StatusInfoPanel__10YIs","col":"StatusInfoPanel_col__2197s"};